'use client';

import dynamic from 'next/dynamic';

/**
 * PWA Components Wrapper
 *
 * Dynamically imports PWA components with SSR disabled to prevent
 * server-side execution of browser-only code.
 *
 * This prevents "Cannot read properties of undefined" errors when
 * these components are used in server components.
 */

// Dynamic imports with SSR disabled
const InstallPromptDynamic = dynamic(() => import('@/components/pwa/install-prompt'), {
  ssr: false,
});

// RULE 15: OfflineIndicator removed to eliminate duplicate network status notifications
// NetworkStatusBanner in layout.tsx provides superior network status UI with:
// - Connection quality detection (poor/fair/good/excellent)
// - Retry functionality
// - Customizable messages
// - Better positioning and animations

const UpdatePromptDynamic = dynamic(() => import('@/components/pwa/update-prompt'), {
  ssr: false,
});

/**
 * PWA Wrapper Component
 *
 * Renders all PWA enhancement components with proper SSR handling.
 */
export function PWAWrapper() {
  return (
    <>
      <InstallPromptDynamic />
      <UpdatePromptDynamic />
    </>
  );
}
